import {required, numeric, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import {USER_GROUPS} from "@/store/auth/auth";
import {ModelObject} from "@/pages/Common/modelObject";

export class Organization extends ModelObject {
    constructor(initObjectParams) {
        super(initObjectParams)
        this.id = null;
        this.name = null;
        this.shortName = null;
        this.inn = null;
        this.ogrn = null;
        this.email = null;
        this.phone = null;
        this.workHours = null;
        this.website = null;

        this.address = null;
        this.addressObject = {};
        this.legalAddress = null;

        this.municipalities = [];
        this.municipalityObjects = [];

        this.groups = null;
        this.groupList = [];
        this.groupObjects = [];
        this.activities = null;
        this.activityList = [];
        this.activityObjects = [];
        this.excludeGroups = [];

        this.publish = false

        this.applyInitObjectParams(initObjectParams)
    }

    static get modelName() {
        return 'Organization'
    }


    static get _baseValidations() {
        return {
            name: {required},
            shortName: {},
            groupList: {required},
            inn: {required, minLength: minLength(10), maxLength: maxLength(12), numeric},
            ogrn: {numeric},
            email: {},
            activityList: {required},
            address: {},
            legalAddress: {},
            workHours: {},
            phone: {},
            website: {},
            publish: {}
        }
    }

    static get municipalityValidations() {
        return {...Organization._baseValidations, ...{ municipalities: { required } }}
    }

    static get validations() {
        return {...Organization._baseValidations, ...{ municipalities: {  } }}
    }

    static get validationFieldLabels() {
        return {
            name: 'Название',
            shortName: 'Краткое название',
            groupList: 'Группы',
            activityList: 'Виды деятельности',
            municipalities: 'Муниципалитеты',
            email: 'Адрес электронной почты',
            inn: 'ИНН',
            ogrn: 'ОГРН',
            address: 'Фактический адрес',
            legalAddress: 'Юридический адрес',
            workHours: 'Часы работы',
            phone: 'Телефон',
            website: 'Ссылка на сайт',
            publish: 'Публиковать на сайте'
        }
    }

    static get mapping() {
        return {
            shortName: 'short_name',
            groupList: 'group_list',
            activityList: 'activity_list',
            workHours: 'work_hours',
            legalAddress: 'legal_address'
        }
    }

    static get label() {
        return 'Организация'
    }

    label() {
        return 'Организация'
    }

    static get newLabel() {
        return 'Организация'
    }

    objectLabel() {
        return this.shortName ? this.shortName : this.name
    }

    get activityTexts() {
        return this.activityObjects.map(x => x.name)
    }

    get groupTexts() {
        return this.groupObjects.map(x => x.name)
    }

    get municipalityTexts() {
        return this.municipalityObjects.map(x => x['short_name'])
    }

    get coordinates() {
        return { lat: this.addressObject['lat'], lon: this.addressObject['lon'] }
    }

    get addressHumanReadable() {
        return this.id && this.addressObject ? this.addressObject['short_text'] : null
    }

    applyData(data) {
        super.applyData(data)
        for (let g of this.groupObjects) {
            g['can_remove'] = this.excludeGroups && !this.excludeGroups.includes(g['id']);
        }
        const regex = /^https?:\/\//;
        if (this.website && this.website.match(regex)) {
            this.website = this.website.replace(regex, '')
        }
    }

}